import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setAssetCreateOrEditTypeAction,
  toggleModalAction,
} from "store/actions/actions";
import Title from "components/title/Title";
import Table from "tools/components/v1/widgets/Table/Table";
import NoItems from "tools/components/v1/widgets/NoItems/NoItems";
import ApiCallHandler from "shared/js/ApiCallHandler";
import URLS from "shared/js/urls";
import { withRouter } from "react-router-dom";
import ShowActions from "../../../../../shared/components/showActions/ShowActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import CreateAsset from "../create/CreateAsset";
import { editMutationAction } from "../../../../../store/actions/actions";

class AllAssets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      showActions: false,
    };
  }

  handleShowDetail = (item) => {
    this.props.history.push("/opportunities/asset/" + item.id);
  };

  toggleShowMoreOptions = (item) => {
    if (!item?.id) {
      this.setState({
        showActions: false,
        id: "",
      });
    } else {
      this.setState({
        showActions: true,
        id: item?.id,
      });
    }
  };

  prepareTableData = () => {
    let { allAssets } = this.props;
    let tableData = (allAssets || []).map((item) => {
      return [
        <p onClick={() => this.handleShowDetail(item)}>
          {item?.name || "Not Set"}
        </p>,
        <p onClick={() => this.handleShowDetail(item)}>
          {item?.cost || "Not Set"}
        </p>,
        <p onClick={() => this.handleShowDetail(item)}>
          {item?.asset_type?.name || "Not Set"}
        </p>,
        <p onClick={() => this.handleShowDetail(item)}>
          {item?.identification_number || "Not Set"}
        </p>,
        <p>{item?.identification_number_name || "Not Set"}</p>,
        <p></p>,
        <ShowActions
          onEdit={this.handleToggleAddOrEditModal}
          onDelete={this.handleDeleteAsset}
          onView={this.handleShowDetail}
          item={item}
          id={this.state.id}
          toggleShowMoreOptions={this.toggleShowMoreOptions}
          show={this.state.showActions}
        />,
      ];
    });
    return tableData;
  };
  handleToggleAddOrEditModal = (item = {}) => {
    this.props.toggleModal({
      show: true,
      props: {
        title: `${item?.id ? "Update" : "Create"} Investment Asset`,
        children: (
          <CreateAsset
            item={item}
            close={this.closeModal}
            currentInvestment={this.props.currentInvestment?.id}
          />
        ),
        themeColor: "var(--app-theme)",
        size: "large",
      },
    });
  };
  closeModal = () => {
    this.props.toggleModal({ show: false });
  };

  showAllAssets = () => {
    let { allAssets } = this.props;
    return (
      <div>
        <div>
          <Title
            className="text-toggler"
            onClick={this.handleToggleAddOrEditModal}
          >
            <FontAwesomeIcon icon={faPlus} /> Add New Asset
          </Title>
        </div>
        <div style={{ marginTop: 10 }}>
          {allAssets && allAssets.length ? (
            <Table
              columns={[
                "Name",
                "Cost",
                " Asset Type",
                "ID Number",
                "ID NAME",
                "\t",
                "actions",
              ]}
              data={this.prepareTableData()}
              hoverAnimation={false}
            />
          ) : (
            <NoItems text="No Assets yet" />
          )}
        </div>
      </div>
    );
  };

  deleteItemfromRedux = (id) => {
    let { currentInvestment, investments } = this.props;
    let filteredAsset = currentInvestment?.assets?.filter(
      (item) => item.id !== id
    );
    currentInvestment.assets = filteredAsset;
    this.props.updateItemInredux(investments, currentInvestment);
  };

  handleDeleteAsset = (item) => {
    this.props.toggleModal({
      show: true,
      props: {
        title: `Delete "${item?.name}"`,
        children: `Are you sure you want to delete "${item?.name}"`,
        themeColor: "maroon",
        cancel: true,
        okay: {
          text: "Yes",
          function: () => {
            ApiCallHandler.send(URLS.ARCHIVE_ASSETS, "POST", {
              id: item?.id,
            }).then(() => {
              this.deleteItemfromRedux(item?.id);
            });
          },
        },
      },
    });
  };

  render() {
    return <div>{this.showAllAssets()}</div>;
  }
}

const mapStateToProps = (state, ownerProps) => {
  const currentInvestment = state.investments.filter(
    (x) => x.id === localStorage.currentInvestmentId
  )[0];
  return {
    allAssets: currentInvestment?.assets,
    investments: state.investments,
    currentInvestment,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setAssetFormStatus: (val) =>
        dispatch(setAssetCreateOrEditTypeAction(val)),
      toggleModal: toggleModalAction,
      updateItemInredux: (current_data, new_data) =>
        dispatch(editMutationAction("INVESTMENT", current_data, new_data)),
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AllAssets)
);
